import {
  SET_CONVO,
  UPDATE_CONVO_MESSAGES,
  UPDATE_CONVO_STATUS,
} from "../Actions/convoActions";

const initialState = null;

const convoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONVO:
      return {
        ...action.payload, // Return a new state object based on the payload
      };

    case UPDATE_CONVO_MESSAGES:
      return {
        ...(state || {}),
        messages: [
          ...((state && state.messages) || []),
          action.message && typeof action.message === "object"
            ? { ...action.message }
            : action.message,
        ],
      };
    case UPDATE_CONVO_STATUS:
      return {
        ...(state || {}),
        ticketId: {
          ...((state && state.ticketId) || {}),
          status: action.status,
        },
      };
    default:
      return state;
  }
};

export default convoReducer;
